export default __webpack_public_path__ + "7be5f18b0776f2a6363d8c55ad5349ed.jpg";